var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShortLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 837.14 414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00de85;}.cls-2{fill:#000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M837.14,290.8c0-25-17.07-42.28-41.11-42.28s-41.12,17.29-41.12,42.28S772,333.09,796,333.09s41.11-17.3,41.11-42.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M442.44,260.5V322H393.39c-56.17,0-90.7-34.53-90.7-91.18V122.14H256.54l25.15-55.51h24.89L306.26.54,370.57,0V66.63H441v55.51H371.74v99.5c0,24.67,14.19,38.86,39.32,38.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.27,66.63,169,318.56C138.38,387.77,111.47,414,54.18,414H25.72V351.92H49.6c33.27,0,41.92-8.85,57.6-47.45l1-2.07L0,66.63H75.14l68.12,157.09L206.84,66.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M675.33,194.3c0-40.11-29.39-70-69.5-70s-69.59,30-69.59,70,29.49,70,69.59,70,69.5-29.89,69.5-70M611.46,59.4c76.91,0,133.76,57.52,133.76,134.9S688.37,329.57,611.46,329.57c-26.45,0-50.45-7.8-70.24-21.5V414h-69V66.64h45.65a22.3,22.3,0,0,0,31,9.33A123.54,123.54,0,0,1,611.48,59.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortLogo);
export default __webpack_public_path__ + "static/media/short-logo.4da042c778c5a031f828ea92b9576e95.svg";
export { ForwardRef as ReactComponent };